import React from 'react'
import PropTypes from 'prop-types'
import { compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import BackIcon from '@material-ui/icons/ArrowBack'
import CircularProgress from '@material-ui/core/CircularProgress'

import { withFormik } from 'formik'
import * as yup from 'yup'
import { withSnackbar } from 'notistack'

import HeroForm from './components/HeroForm'
import BinForm from './components/BinForm'
import { styles } from './styles'
import { connect } from 'react-redux'
import { getHeroMe, saveHeroImage, updateHeroProfile } from '../../stores/hero'
import { compressFile } from '../../utils'

const validationSchema = () => {
  /* istanbul ignore next */
  return yup.object().shape({
    name: yup.string().required('จำเป็นต้องระบุ'),
    firstname: yup.string().required('จำเป็นต้องระบุ'),
    lastname: yup.string().required('จำเป็นต้องระบุ'),
    tel: yup
      .string()
      .matches(/^\d{9,10}$/, 'ไม่สามารถกรอกตัวอักษรและต้องมี 10 หลัก')
      .required('จำเป็นต้องระบุ'),
    address: yup.string().required('จำเป็นต้องระบุ'),
    subDistrict: yup.string().required('จำเป็นต้องระบุ'),
    district: yup.string().required('จำเป็นต้องระบุ'),
    zipcode: yup.string().required('จำเป็นต้องระบุ'),
    email: yup
      .string()
      .matches(
        /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
        'ไม่สามารถกรอกภาษาไทยและใส่รูปแบบของอีเมลให้ถูกต้อง'
      )
      .required('จำเป็นต้องระบุ')
    // lineId: yup
    //   .string()
    //   .matches(/^[a-zA-Z0-9@_.]+$/)
    //   .required('จำเป็นต้องระบุ')
  })
}

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { me, enqueueSnackbar, updateHeroProfile, getHeroMe } = props

  setSubmitting(true)
  const data = {
    id: me.id,
    status: me.status,
    address: values.address,
    district: values.district,
    email: values.email,
    firstName: values.firstname,
    heroName: values.name,
    heroType: values.heroType,
    lastName: values.lastname,
    lineId: values.lineId,
    password: values.password,
    plateLicense: values.plateLicense,
    postalAddress: values.postalAddress,
    province: values.province,
    purpose: values.purpose,
    subDistrict: values.subDistrict,
    tel: values.tel,
    zipcode: values.zipcode
  }
  await updateHeroProfile(data, enqueueSnackbar)
  await getHeroMe()
  setSubmitting(false)
}

export const handleUpload = async ({
  e: {
    target: {
      files: [file]
    }
  },
  heroId,
  saveHeroImage
}) => {
  const formData = new FormData()
  formData.append('heroId', heroId)
  formData.append('image', await compressFile(file))
  await saveHeroImage(formData)
}

export const Profile = ({
  me,
  handleSubmit,
  handleChange,
  handleBlur,
  setFieldValue,
  touched,
  errors,
  values,
  isSubmitting,
  history,
  saveHeroImage
}) => {
  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => history.goBack()}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            โปรไฟล์
          </Typography>
          <Button
            id="btnSubmit"
            style={styles.userButton}
            color="inherit"
            aria-label="Menu"
            onClick={handleSubmit}>
            Update
          </Button>
          {isSubmitting && <CircularProgress color="inherit" size={30} />}
        </Toolbar>
      </AppBar>
      <main style={styles.main}>
        {me.heroType === 'CIRCULAR_BIN' ? (
          <BinForm
            me={me}
            handleSubmit={handleSubmit}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            values={values}
            handleBlur={handleBlur}
            handleUpload={handleUpload}
            saveHeroImage={saveHeroImage}
            setFieldValue={setFieldValue}
          />
        ) : (
          <HeroForm
            me={me}
            handleSubmit={handleSubmit}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            values={values}
            handleBlur={handleBlur}
            handleUpload={handleUpload}
            saveHeroImage={saveHeroImage}
            setFieldValue={setFieldValue}
          />
        )}
      </main>
    </React.Fragment>
  )
}

Profile.propTypes = {
  history: PropTypes.object.isRequired,
  me: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  UploadAvatar: PropTypes.func.isRequired
}

const mapDispatchToProps = {
  updateHeroProfile,
  getHeroMe,
  saveHeroImage
}

export default compose(
  withRouter,
  withSnackbar,
  withApollo,
  connect(null, mapDispatchToProps),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ me }) => {
      return {
        email: (me && me.email) || '',
        binId: me && me.binId,
        name: (me && me.name) || '',
        firstname: (me && me.firstName) || '',
        lastname: (me && me.lastName) || '',
        tel: (me && me.tel) || '',
        lineId: (me && me.lineId) || '',
        address: (me && me.address) || '',
        subDistrict: (me && me.subDistrict) || '',
        district: (me && me.district) || '',
        province: (me && me.province) || '',
        zipcode: (me && me.zipCode) || '',
        plateLicense: (me && me.plateLicense) || '',
        purpose: (me && me.purpose) || '',
        postalAddress: (me && me.postalAddress) || '',
        heroType: (me && me.heroType) || '',
        isPublic: me && me.isPublic,
        isQuick: me && me.isQuick,
        hasTool: me && me.hasTool
      }
    },
    handleSubmit,
    validationSchema,
    displayName: 'ProfileForm'
  })
)(Profile)



// WEBPACK FOOTER //
// ./src/pages/Profile/index.js